import { render, staticRenderFns } from "./SendDocumentTemplateList.vue?vue&type=template&id=c82ac8d0&scoped=true&lang=pug"
import script from "./SendDocumentTemplateList.vue?vue&type=script&lang=ts"
export * from "./SendDocumentTemplateList.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentTemplateList.vue?vue&type=style&index=0&id=c82ac8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82ac8d0",
  null
  
)

export default component.exports